// 네이티브(Android)에서 제공하는 뷰포트 값을 읽어 CSS px로 환산
export type AndroidCssViewport = { cssW: number; cssH: number; dpr: number } | null;

export function readAndroidCssViewport(): AndroidCssViewport {
    try {
        const A: any = (window as any).Android;
        if (!A) return null;

        // 1) getWebViewSize() JSON이 제일 정확
        let meta: any = null;
        try { meta = A.getWebViewSize ? JSON.parse(A.getWebViewSize()) : null; } catch {}

        const wPx  = Number(A.getViewWidthPx?.())  || Number(meta?.wPx)  || 0;
        const hPx  = Number(A.getViewHeightPx?.()) || Number(meta?.hPx)  || 0;
        const dpr  = Number(meta?.approxDpr) || Number(meta?.density) || window.devicePixelRatio || 1;
        const cssW = Number(meta?.cssApprox?.w) || (wPx && dpr ? wPx / dpr : 0);
        const cssH = Number(meta?.cssApprox?.h) || (hPx && dpr ? hPx / dpr : 0);

        if (cssW && cssH) return { cssW: Math.round(cssW), cssH: Math.round(cssH), dpr: dpr || 1 };
    } catch {}
    return null;
}
